import { Outlet, NavLink, useNavigate, useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@apollo/client';
import { Button } from '@semsis/ui/Button';
import { Spinner } from '@semsis/ui/Spinner';
import { SubNav, SubNavHeader, SubNavItem } from '@semsis/ui/SubNav';
import { LIST_CATALOG_GROUPS } from '../graphql/operations';

export function CatalogLayout() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { groupId } = useParams<{ groupId: string }>();

  const { data, loading } = useQuery(LIST_CATALOG_GROUPS);
  const groups = data?.listCatalogGroups ?? [];

  return (
    <>
      <SubNav aria-label={t('catalogs.title')}>
        <SubNavHeader
          label={t('catalogs.title')}
          actions={
            <Button variant="ghost" onClick={() => navigate('/catalogs/create')}>+</Button>
          }
        />
        {loading && <Spinner small />}
        {groups.map((group) => (
          <SubNavItem
            key={group.id}
            asChild
            label={group.name}
            active={groupId === group.id}
          >
            <NavLink to={`/catalogs/${group.id}`} />
          </SubNavItem>
        ))}
      </SubNav>
      <Outlet />
    </>
  );
}
